import { render, staticRenderFns } from "./TemplateClient.vue?vue&type=template&id=1b61cbe4&"
import script from "./TemplateClient.vue?vue&type=script&lang=js&"
export * from "./TemplateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports